import { Controller } from 'lib/stimulus-instance'

export default class InvitationCodeController extends Controller {
  static values = { path: String }
  static targets = ['inputField', 'spinner', 'error']
  static classes = ['base']
  static answers = [
    'f8a1e2dd47659f55edfb5fef7c25d6806edf12e50af2363816e3550617bca3317a4fc9886f08514d852b69a1ed9bf190d5f535903354e2941a'
    + 'af8b616c196b33',
    '76bfd7070d57aa655c481db51917314fa19eab0651517582f02d13d0ce8c9a7b52312cae24c7bc7bb432e0dd843271967fa165aaaa402723ac'
    + '6ae10a41d23dd3',
  ]

  async submit () {
    this.success = false
    this.working = true
    this.errorMessage = ''
    await new Promise(resolve => setTimeout(resolve, 1000))
    const code = this.inputFieldTarget.value.trim().toUpperCase()
    if (this.constructor.answers.includes(await this.#shaDigest(code))) {
      this.working = false
      this.success = true
      this.dispatch('valid')
    } else {
      this.working = false
      this.errorMessage = 'Invalid code'
      this.dispatch('invalid')
    }
  }

  async #shaDigest (data) {
    const encoder = new TextEncoder()
    const dataBuffer = encoder.encode(data)
    const hashBuffer = await crypto.subtle.digest('SHA-512', dataBuffer)
    return Array.from(new Uint8Array(hashBuffer))
      .map(byte => byte.toString(16).padStart(2, '0'))
      .join('')
  }

  /**
   * @param {Boolean} value
   */
  set working (working) {
    this._working = working
    if (working) {
      this.element.classList.add(`${this.baseClass}--working`)
    } else {
      this.element.classList.remove(`${this.baseClass}--working`)
    }
  }

  get working () {
    return this._working
  }

  /**
   * @param {String} error
   */
  set errorMessage (error) {
    this.errorTarget.innerText = error
    if (error.length > 0) {
      this.element.classList.add(`${this.baseClass}--error`)
    } else {
      this.element.classList.remove(`${this.baseClass}--error`)
    }
  }

  get errorMessage () {
    return this.errorTarget.innerText
  }

  /**
   * @param {String} success
   */
  set success (success) {
    this._success = success
    success && this.element.classList.add(`${this.baseClass}--success`)
    success || this.element.classList.remove(`${this.baseClass}--success`)
  }

  get success () {
    return this._success
  }
}
